import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'

import KanseiTextField from 'components/copied/textField'
import { authApi } from 'hooks/api/auth'
import { addSnackbar } from 'store/snackbarSlice'

import LoginLogoComponent from './components/loginLogo'

interface Form {
  id: string
  pass: string
}

export default function LoginPage() {
  const dispatch = useDispatch()
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Form>()

  const submit = (form: Form) => {
    authApi()
      .signin(form.id, form.pass)
      .then(() => {
        // index.tsxの認証済みステータスが更新されないため、強制移動
        location.href = '/security'
      })
      .catch(() => {
        dispatch(
          addSnackbar({
            message: 'ID,またはパスワードが正しくありません',
            severity: 'warning',
          }),
        )
      })
  }

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <LoginLogoComponent />
        <Box
          component="form"
          noValidate
          onSubmit={handleSubmit(submit)}
          sx={{ mt: 3 }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <KanseiTextField
                id="id"
                label="ID"
                register={register('id', { required: true })}
                errors={errors}
              ></KanseiTextField>
              {errors.id && <p role="alert">idを入力してください</p>}
            </Grid>
            <Grid item xs={12}>
              <KanseiTextField
                id="pass"
                label="パスワード"
                type="password"
                register={register('pass', { required: true })}
                errors={errors}
              ></KanseiTextField>
              {errors.pass && <p role="alert">passwordを入力してください</p>}
            </Grid>
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2, height: '33px' }}
          >
            ログイン
          </Button>
        </Box>
      </Box>
    </Container>
  )
}
